import React from 'react';
import { RotateCcw } from 'lucide-react';
import { TAIWAN_CITIES } from '../../utils/taiwanCities';
import { INTERESTS } from '../../utils/profileConstants';

// Re-designed FilterPanel with standard HTML elements and inline styles
const FilterPanel = ({ filters, onFiltersChange, onReset, isMobile }) => {

  const panelStyle = {
    display: 'flex',
    gap: isMobile ? '12px' : '16px',
    alignItems: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    width: isMobile ? '100%' : 'auto',
    flexWrap: 'wrap',
  };

  const selectStyle = {
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    background: 'white',
    minWidth: isMobile ? '100%' : '120px',
    width: isMobile ? '100%' : 'auto',
    fontSize: '14px',
  };

  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div style={panelStyle}>
      <select
        style={selectStyle}
        value={filters.gender}
        onChange={(e) => handleFilterChange('gender', e.target.value)}
      >
        <option value="all">全部性別</option>
        <option value="男">男性</option>
        <option value="女">女性</option>
        <option value="其他">其他</option>
      </select>

      <select
        style={selectStyle}
        value={filters.age_range}
        onChange={(e) => handleFilterChange('age_range', e.target.value)}
      >
        <option value="all">全部年齡</option>
        <option value="18-25">18-25</option>
        <option value="26-35">26-35</option>
        <option value="36-45">36-45</option>
        <option value="46+">46+</option>
      </select>

      <select
        style={selectStyle}
        value={filters.city}
        onChange={(e) => handleFilterChange('city', e.target.value)}
      >
        <option value="all">所有縣市</option>
        {TAIWAN_CITIES.map(city => (
          <option key={city} value={city}>{city}</option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.interest}
        onChange={(e) => handleFilterChange('interest', e.target.value)}
      >
        <option value="all">全部興趣</option>
        {INTERESTS.map(interest => (
          <option key={interest} value={interest}>{interest}</option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.sort_by}
        onChange={(e) => handleFilterChange('sort_by', e.target.value)}
      >
        <option value="latest">最新註冊</option>
        <option value="age_asc">年齡由低到高</option>
        <option value="age_desc">年齡由高到低</option>
      </select>

      {onReset && (
        <button
          onClick={onReset}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            padding: '8px 14px',
            borderRadius: '8px',
            border: '1px solid #ddd',
            background: 'white',
            color: '#6b7280',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            width: isMobile ? '100%' : 'auto',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f1f5f9';
            e.currentTarget.style.color = '#374151';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.color = '#6b7280';
          }}
        >
          <RotateCcw size={14} />
          重置
        </button>
      )}
    </div>
  );
};

export default FilterPanel;
